




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import OperatorFilters from '@/components/OperatorFilters.vue';
import OperatorCard from '@/components/OperatorCard.vue';
import { OperatorModel } from '@/models/Operator';
import { GroupModel } from '@/models/Group';

const operatorModule = namespace('OperatorStore');
const groupModule = namespace('GroupStore');

@Component({
  components: {
    OperatorFilters,
    OperatorCard,
  },
})
export default class Operators extends Vue {
    @operatorModule.State private operators!: OperatorModel[];
    @groupModule.State private drawedGroup!: GroupModel;
    @groupModule.State private choicedOperators!: OperatorModel[];

    @Prop() targetOperatorIdx!: number;
    @Prop() functionChoiced!: (targetIdx: number, choiced: OperatorModel) => void;
    @Prop() functionClose!: () => void;

    get nonPriorityOperators(): OperatorModel[] {
        const priorityIds = this.drawedGroup.operators.map((operator) => operator.id);
        const choicedIds = this.choicedOperators.map((operator) => operator.id);
        return this.operators.filter((operator) => {
            return !priorityIds.includes(operator.id) && !choicedIds.includes(operator.id) && operator.visible;
        });
    }
}
